import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { format, formatDistanceToNow } from 'date-fns';
import { ru } from 'date-fns/locale';

import styles from './styles.module.scss';

const PublicationDateData = ({ content = {} }) => {
  const { t } = useTranslation();

  // Дата публикации = created_at
  const publicationDate = useMemo(() => {
    if (content.created_at) {
      return format(new Date(content.created_at), 'dd.MM.yyyy,HH:mm');
    }
    return '';
  }, [content.created_at]);

  // "Подняли X назад" - показываем только если last_up_to_top_at отличается от created_at
  const timeAgo = useMemo(() => {
    if (content.last_up_to_top_at && content.created_at) {
      const lastUpToTopDate = new Date(content.last_up_to_top_at);
      const createdDate = new Date(content.created_at);
      const now = new Date();

      // Проверяем что last_up_to_top_at отличается от created_at (было "поднятие")
      const wasRaised = lastUpToTopDate.getTime() !== createdDate.getTime();

      if (wasRaised) {
        const diffInHours = (now - lastUpToTopDate) / (1000 * 60 * 60);

        // Показываем бейдж только если обновлено менее 48 часов назад
        if (diffInHours < 48) {
          return formatDistanceToNow(lastUpToTopDate, {
            addSuffix: false,
            locale: ru,
          });
        }
      }
    }
    return null;
  }, [content.last_up_to_top_at, content.created_at]);

  return (
    <div className={styles.publication}>
      <div className={styles.publication__date}>{publicationDate}</div>
      {timeAgo && (
        <div className={styles.publication__badge}>
          <span className={styles.publication__badgeText}>{t('transport.table.raisedAgo', { time: timeAgo })}</span>
        </div>
      )}
    </div>
  );
};

export default PublicationDateData;
